import React from "react";
import { createPortal } from "react-dom";

type PortalProps = {
  children: React.ReactNode;
  containerId?: string; // default "modal-root"
};

const Portal: React.FC<PortalProps> = ({
  children,
  containerId = "modal-root",
}) => {
  const [mountNode, setMountNode] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    if (typeof document === "undefined") return;
    let el = document.getElementById(containerId);
    if (!el) {
      el = document.createElement("div");
      el.id = containerId;
      document.body.appendChild(el);
    }
    setMountNode(el);
  }, [containerId]);

  if (!mountNode) return null;
  return createPortal(children, mountNode);
};

export default Portal;
